import { useState } from 'react'

import { F0Box, F0Button, F0Text } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

import ErrorModal from 'modules/integrations_primobox/components/ErrorModal'
import StatusTagF0 from 'modules/integrations_primobox/components/StatusTag/StatusTagF0'
import type Status from 'modules/integrations_primobox/lib/interfaces/Status'

interface Props {
  title?: string
  status: Status
  inModal: boolean
}

const StatusBlockF0 = ({ status, title, inModal }: Props) => {
  const [showErrorModal, setShowErrorModal] = useState(false)

  return (
    <>
      <F0Box
        display="flex"
        flexDirection="column"
        gap="md"
        {...(!inModal && { padding: 'lg', background: 'secondary', borderRadius: 'sm' })}
      >
        {title && <F0Text variant="label" content={title} />}

        <StatusTagF0 status={status} />

        {status.messages.length > 0 && inModal && (
          <F0Box display="flex" flexDirection="column" gap="xs">
            {status.messages.map((message, index) => (
              <F0Text key={index} variant="description" content={message} />
            ))}
          </F0Box>
        )}

        {status.messages.length > 0 && !inModal && (
          <F0Box display="flex" justifyContent="end">
            <F0Button
              onClick={() => setShowErrorModal(true)}
              variant="outline"
              label={i18n.t('integrations_primobox.error_modal.button')}
            />
          </F0Box>
        )}
      </F0Box>

      {showErrorModal && !inModal && (
        <ErrorModal status={status} onClose={() => setShowErrorModal(false)} />
      )}
    </>
  )
}

export default StatusBlockF0
